import { scrollToHash } from 'client/utils/scroll';
import { INVENTORY_SCROLL_TO_TOP_ANCHOR } from 'site-modules/personalized-search/constants/inventory';

export function scrollToTop(hash = INVENTORY_SCROLL_TO_TOP_ANCHOR, options) {
  scrollToHash(`#${hash}`, options);
}
